import { DeleteDocument, DeleteDocumentToken } from "$src/application/projects/sub/documents/commands/DeleteDocument";
import { DocumentIdentifier } from "$src/domain/projects/documents/DocumentIdentifier";
import { useMutation, useQueryClient } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function deleteDocument(groupStoreId: number, projectId: number, documentId: string): Promise<DocumentIdentifier> {
    const query = container.resolve<DeleteDocument>(DeleteDocumentToken);
    return query.execute(groupStoreId, projectId, documentId);
}

export function useDeleteDocument() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ groupStoreId, projectId, documentId }: 
            { groupStoreId: number, projectId: number, documentId: string }
        ) => deleteDocument(groupStoreId, projectId, documentId),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['documents']);
                queryClient.invalidateQueries(['document']);
            },
            onError: (error: Error) => {
                console.error('Failed to delete document:', error);
            },
            onSettled: () => {
            },
        }
    );
}